import { Box, Link, Text } from '@nimbus-ds/components';
import { Link as LinkRoute } from 'react-router-dom';
import { ExternalLink, useResponsive } from 'commons/components';
import { PromoteGroupedIcon } from '../PromoteGroupedIcon';
import PromoteIcon from '../PromoteIcon';
import RecommendationIcon from '../RecommendationIcon';
import { TaskData, ContentType, ActionType, TaskActionData } from '../types';

interface TaskContentProps {
  data: TaskData & TaskActionData;
  contentType: ContentType;
  actionType: ActionType;
  onAction: (data: TaskData & TaskActionData) => void;
}

function TaskContent({
  data,
  contentType,
  actionType,
  onAction,
}: TaskContentProps) {
  const { isMobile: isMobileResponsive } = useResponsive();

  const getGap = () => {
    if (contentType === 'promoteGrouped') return 'none';
    if (contentType === 'promote') return '3';
    return '2';
  };

  return (
    <Box display="flex" gap={getGap()}>
      {contentType === 'promote' && <PromoteIcon type={data.iconType} />}
      {contentType === 'recommendation' && (
        <RecommendationIcon type={data.iconType} />
      )}
      {contentType === 'promoteGrouped' && (
        <PromoteGroupedIcon type={data.id} />
      )}
      <Box display="flex" flexDirection="column" gap="none" alignSelf="center">
        <Text fontSize="caption" color="neutral-textHigh" lineHeight="caption">
          {data.title}
        </Text>
        <Text fontSize="caption" color="neutral-textLow" lineHeight="caption">
          {data.description}
        </Text>
        {isMobileResponsive && actionType === 'promote' && (
          <Box>
            {data.ctaExternal ? (
              <ExternalLink
                href={data.ctaLink}
                textDecoration="none"
                appearance="primary"
                fontSize="caption"
                onClick={() => onAction(data)}
              >
                {data.ctaText}
              </ExternalLink>
            ) : (
              <Link
                data-style="task-action-link"
                textDecoration="none"
                appearance="primary"
                fontSize="caption"
                lineHeight="caption"
                as={LinkRoute}
                onClick={() => onAction(data)}
                to={data.ctaLink || '#'}
              >
                {data.ctaText || 'Acción'}
              </Link>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default TaskContent;
